var _rect, _g, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "url(#paint0_linear_169_161)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_169_161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.23145,
    y: 24,
    width: 32.6987,
    height: 20.4367,
    rx: 10.2183,
    fill: "url(#paint1_linear_169_161)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.23999,
    y: 6.24023,
    width: 35.4236,
    height: 35.4236,
    rx: 17.7118,
    fill: "url(#paint2_linear_169_161)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_169_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1998 19.383C32.9799 18.5562 32.3293 17.904 31.5015 17.6804C30.0049 17.2793 23.9999 17.2793 23.9999 17.2793C23.9999 17.2793 17.998 17.2793 16.4983 17.6804C15.6736 17.9009 15.023 18.5532 14.8 19.383C14.3999 20.8835 14.3999 24.0161 14.3999 24.0161C14.3999 24.0161 14.3999 27.1488 14.8 28.6492C15.0199 29.476 15.6705 30.1283 16.4983 30.3518C17.998 30.753 23.9999 30.753 23.9999 30.753C23.9999 30.753 30.0049 30.753 31.5015 30.3518C32.3262 30.1314 32.9768 29.4791 33.1998 28.6492C33.5999 27.1488 33.5999 24.0161 33.5999 24.0161C33.5999 24.0161 33.5999 20.8835 33.1998 19.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0817 26.9038L27.0696 24.0161L22.0817 21.1285V26.9038Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_169_161",
    x: 1.77145,
    y: 18.54,
    width: 43.6187,
    height: 31.3575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_169_161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_169_161",
    x: 12.96,
    y: 13.4395,
    width: 21.6,
    height: 22.0996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_169_161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_161",
    x1: 4.03493,
    y1: 3.1441,
    x2: 39.6681,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_161",
    x1: 25.8407,
    y1: 45.0462,
    x2: 19.1756,
    y2: 21.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_161",
    x1: 26.4,
    y1: 42.7202,
    x2: 9.83999,
    y2: 6.24023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.9001cf0bfa8c9e974f18b2739cd62f8e.svg";
export { ForwardRef as ReactComponent };